module.exports = __webpack_public_path__ + "img/cat-3.36933938.png";